/** dataLayer Custom Event 名称（与 GTM 触发器 Event name 一致） */
export enum GtmEvent {
  // --- 页面 ---
  PageView = "page_view",

  // --- 转化 ---
  RegisterSuccess = "register_success",

  // --- 侧边栏导航 ---
  GoToVideo = "go_to_video",
  GoToInsight = "go_to_insight",
  GoToScriptRewrite = "go_to_script_rewrite",
  GoToSocialPublisher = "go_to_social_publisher",
  GoToLibrary = "go_to_library",

  // 积分
  GoToViewCredits = "view_credits",
  PayNow = "pay_now",

  PaySuccessfulManually = "pay_successful_manually",
  PayFailedManually = "pay_failed_manually",
  PurchaseCreditsSuccessfully = "purchase_credits_successfully",

  // 视频创作
  GoToCreateWithLink = "go_to_create_with_link",
  GoToUploadProductImage = "go_to_upload_product_image",

  // 脚本拆解
  GoToCreateScriptWithLink = "go_to_create_script_with_link",
  // 脚本撰写
  GoToGenerateScript = "go_to_generate_script",
  GoToRegenerateScript = "go_to_regenerate_script",
}

/** 侧边栏可上报的导航事件子集 */
export type GtmSidebarNavigationEvent =
  | GtmEvent.GoToVideo
  | GtmEvent.GoToInsight
  | GtmEvent.GoToScriptRewrite
  | GtmEvent.GoToSocialPublisher
  | GtmEvent.GoToLibrary;

/** 路由 → 侧边栏 GTM 事件（单一映射，便于审计） */
export const GTM_SIDEBAR_LINK_EVENT: Record<string, GtmSidebarNavigationEvent> = {
  "/video": GtmEvent.GoToVideo,
  "/insight": GtmEvent.GoToInsight,
  "/script-rewrite": GtmEvent.GoToScriptRewrite,
  "/social-publisher": GtmEvent.GoToSocialPublisher,
  "/library": GtmEvent.GoToLibrary,
};

/** register_success 附带的注册方式（仅产品支持的三种） */
export enum GtmSignupMethod {
  Email = "email",
  Phone = "phone",
  Google = "google",
}
